import { render, staticRenderFns } from "./NavigationTask.vue?vue&type=template&id=56e99004&scoped=true"
import script from "./NavigationTask.vue?vue&type=script&lang=js"
export * from "./NavigationTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e99004",
  null
  
)

export default component.exports